<div
  [class.disabled]="form.disabled"
  class="listbox"
>
  @if (showToggleAll || filter) {
    <div
      class="listbox-header"
    >
      @if (showToggleAll) {
        <app-checkbox
          [binary]="true"
          [formControl]="form.get('allSelected')"
          [indeterminate]="anyVisibleSelected"
          class="checkbox"
        >
        </app-checkbox>
      }
      @if (filter) {
        <span class="filter-input">
          <i class="search-icon"></i>
          <input
            [formControl]="form.get('filter')"
            [placeholder]="filterPlaceholder"
            appInput
            tabindex="-1"
          >
        </span>
      }
    </div>
  }
  <div class="listbox-list-wrapper">
    <app-scrollbar
      #scrollContainer
      viewClass="listbox-list-wrapper-scrollbar"
    >
      <div
        [hidden]="noSearchResultsHidden()"
        class="no-search-results"
      >
        {{ 'proget_shared.search.no_results' | translate }}
      </div>
      <ul
        (mouseout)="setHoverIndex(null, 'mouse')"
        class="listbox-list"
      >
        <ng-container #list></ng-container>
      </ul>
    </app-scrollbar>
  </div>
</div>
<ng-template
  #listItemTemplate
  let-element
>
  <li
    [class.disabled]="element.disabled"
    [class.hover]="element.index === hoverIndex"
    [class.selected]="isItemSelected(element.item)"
    [hidden]="!element.visibility"
    (click)="onItemClick($event, element)"
    (dblclick)="onItemDblClick($event, element)"
    (mouseover)="setHoverIndex(element, 'mouse')"
    class="listbox-item"
  >
    @if (checkbox) {
      <app-checkbox
        [formControl]="form.get('selection')"
        [value]="getItemValue(element.item)"
        (click)="$event.stopPropagation()"
        class="checkbox"
      >
      </app-checkbox>
    }
    <ng-container
      [ngTemplateOutlet]="itemTemplate"
      [ngTemplateOutletContext]="{ $implicit: element.item }"
    ></ng-container>
  </li>
</ng-template>
<ng-template
  #defaultItemTemplate
  let-item
>
  <span
    [title]="item.label"
    class="item-label"
  >
    {{ item.label }}
  </span>
</ng-template>
